export const ALLOW_FOR_NUMBER_INPUT: Array<string> = [
  'Delete',
  'Backspace',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
];
